import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b63763a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-wrap"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改信息", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right-green-svg" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "block-info-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "产品品牌", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "机型", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "序列号", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "设备情况"),
  /*#__PURE__*/_createElementVNode("div", { class: "value" }, "部件齐全；功能完好；")
], -1))
const _hoisted_14 = { class: "block-info-list" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "订单编号", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "创建时间", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "定金支付时间", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "核验通过时间", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "尾款支付时间", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "网点发货时间", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { key: 4 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "确认收货时间", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { key: 5 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "取消时间", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "popup-select-container" }
const _hoisted_38 = { class: "popup-top xag-flex-lr" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "取消申请", -1))
const _hoisted_40 = { class: "reason-wrap" }
const _hoisted_41 = { class: "tips" }
const _hoisted_42 = {
  key: 0,
  class: "cancel-wraning"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请选择取消申请的原因（必选）:", -1))
const _hoisted_44 = {
  class: "popuo-bottom form-footer device-replace-button-wrap",
  style: {"margin-top":"40px"}
}
const _hoisted_45 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_46 = { class: "xag-flex" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, Ref, reactive, computed, ComputedRef } from 'vue'
import AppHeader from '@/components/Header.vue'
import getRoute from '@/compositions/route'
import RecordProductWrapper from './components/record-product-block.vue'
import RecordBlockWrapper from './components/record-block-wrap.vue'
import { getApplyRecordDetail, cancelOrder, confirmReceiveProduct } from '@/apis/device-replace-v3'
import { Toast, Button, PullRefresh, Popup, RadioGroup, Radio, Dialog } from 'vant'
import {
  RecordDetail,
  PayDetailItem,
  RecordDetailKeyDetail,
  RecordDetailReduceDetail,
} from '@/types/device-replace-v3'
import { useRouter, Router } from 'vue-router'
import { showConfirmModal, showToastFail, showToastLoading, showToastSuccess } from '@/utils/tools'
import { statusColorMap, payStatusTextMap, reasonList, parameterCacheKey } from './definition'
import { AxiosError } from 'axios'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'record-detail',
  setup(__props) {

const oldRecordTime = dayjs('2022-11-21 10:00:00').unix()
const $router: Router = useRouter()
const { query: routeQuery } = getRoute()
const guid = routeQuery.value.guid as string
let onLeftClick = function () {
  $router.replace({
    name: 'device-replace-v3-record-list',
  })
}
const pHeightMax = computed(() => {
  const height = window.innerHeight
  return height * 0.9
})

const checkColor = '#00B359'
const refreshing = ref(false)
const detail = reactive({
  guid: '',
  sn: '',
  status: 0,
  status_text: '',
  status_remark: '',
  status_color: '#F7981C',
  product_name: '',
  product_sn: '',
  brand: 1, // 品牌
  brand_text: '',
  model_type: '', // 产品类型
  model_type_text: '',
  model: '',
  code: '',
  create_at: '',
  create_at_unix: 0, // 订单创建的时间戳
  verification_at: '', // 核验通过时间
  send_time: '', //发货时间
  update_at: '', // 订单更新时间
  client_name: '',
  client_guid: '',
  is_change: 0, // 是否已更改过套餐
  price: 0,
  pay_status: 11,
  pay_status_text: '',
  pay_detail: [],
  detail: [],
  new_product: {},
  new_product_child: [],
})

const isOldRecord: ComputedRef<boolean> = computed(() => {
  return detail.create_at_unix < oldRecordTime
})
const statusRemark: ComputedRef<string> = computed(() => {
  const status_remark = detail.status_remark
  const status = detail.status
  if (!isOldRecord.value && status === 11) {
    return '订单如未支付，将在创建后30分后自动取消'
  }
  return status_remark
})

const front_money_pay_at: ComputedRef<string> = computed(() => {
  let time = ''
  const payInfo: PayDetailItem | undefined =
    detail.pay_detail.find((info: PayDetailItem) => {
      return info.type === 1 // 筛选出定金的支付信息
    }) || undefined
  if (payInfo && payInfo.status === 2) {
    time = payInfo.update_at
  }
  return time
})
const rest_money_pay_at: ComputedRef<string> = computed(() => {
  let time = ''
  const payInfo: PayDetailItem | undefined =
    detail.pay_detail.find((info: PayDetailItem) => {
      return info.type === 2 // 筛选出尾款的支付信息
    }) || undefined
  if (payInfo && payInfo.status === 2) {
    time = payInfo.update_at
  }
  return time
})

// 显示底部按钮: 支付定金 取消，支付尾款 确认收货
const canShowFooterStatusMap = [1, 2, 3, 5, 11]
const showFooter: ComputedRef<boolean> = computed(() => {
  if (isOldRecord.value) return false
  const status = detail.status
  return canShowFooterStatusMap.indexOf(status) !== -1
})
// 底部按钮文案
const buttonText: ComputedRef<string> = computed(() => {
  const status = detail.status
  if (status === 1 || status === 2) {
    return '取消申请'
  } else if (status === 3) {
    return '支付尾款'
  } else if (status === 5) {
    return '确认收货'
  } else if (status === 11) {
    return '继续支付定金'
  }
  return ''
})
const buttonClass: ComputedRef<string> = computed(() => {
  const status = detail.status
  if (status === 1 || status === 2) {
    return 'xa-vant-button-cancel'
  }
  return 'xa-vant-button'
})

const showCancelSubButton: ComputedRef<boolean> = computed(() => {
  const status = detail.status
  if (status === 3 || status === 11) {
    return true
  }
  return false
})

function buttonClickHandle() {
  const status = detail.status
  if (status === 3) {
    // 待支付尾款
    $router.push({
      name: 'device-replace-v3-pay-rest-money',
      query: {
        guid: detail.guid,
      },
    })
  } else if (status === 1 || status === 2) {
    showCancelOrderReason()
  } else if (status === 5) {
    confirmReceiveProductHandle()
  } else if (status === 11) {
    // 定金待支付
    $router.push({
      name: 'device-replace-v3-pay-front-money',
      query: {
        guid: detail.guid,
      },
    })
  }
}

const cancelRemark = ref('')
const cancelReasonShow = ref(false)
function showCancelOrderReason() {
  cancelRemark.value = ''
  cancelReasonShow.value = true
}
async function cancelOrderHandle() {
  if (!cancelRemark.value)
    return Dialog({
      message: '请选择取消原因',
      confirmButtonText: '我知道了',
      className: 'repair-dialog',
      width: 304,
    })
  try {
    await showConfirmModal({ title: '是否确认取消申请?' })
    showToastLoading()
    await cancelOrder({ guid, remark: cancelRemark.value })
    cancelReasonShow.value = false
    showToastSuccess('取消成功')
    setTimeout(() => {
      initPageDetail()
    }, 500)
  } catch (error) {
    if (!error) {
      return
    }
    showToastFail((error && error.message) || '取消失败')
  }
}
async function confirmReceiveProductHandle() {
  // 确认收货
  try {
    await showConfirmModal({ title: '是否确认收货?' })
    showToastLoading()
    await confirmReceiveProduct({ guid })
    showToastSuccess('确认成功')
    setTimeout(() => {
      initPageDetail()
    }, 500)
  } catch (error) {
    if (!error) {
      return
    }
    showToastFail((error && error.message) || '确认失败')
  }
}
// 可修改设备信息: 核验通过之前： status === 1, 2, 11
const canEditRecord: ComputedRef<boolean> = computed(() => {
  let status = detail.status
  return status === 1 || status === 2 || status === 11
})
function toEditRecord() {
  setDataCache()
  $router.push({
    name: 'device-replace-v3-apply-form',
    query: { record: detail.guid },
  })
}
// 设置缓存信息
function setDataCache() {
  // 设置parameter数据缓存
  sessionStorage.setItem(
    parameterCacheKey,
    JSON.stringify({
      parameter: {
        radio_isXAG: detail.brand === 1 ? '1' : '0',
        radio_substitution: '0', //是否随同机型配套的播撒器置换 0、1'
        radio_complete: '1', //部件是否齐全0、1
        radio_undamaged: '1', //功能是否完好
        radio_match: '1', //是否符合补贴要求
        radio_completeAndUndamaged: '1', // 功能，部件是否完好
        model: detail.model, //型号
        brand: detail.brand + '',
        brand_name: detail.brand_text,
        model_type: detail.model_type + '', //产品类型
        model_type_text: detail.model_type_text,
        product_sn: detail.product_sn,
        product_name: detail.product_name,
        code: detail.code,
        client_guid: detail.client_guid,
        client_name: detail.client_name,
      },
    })
  )
}

// 可更换套餐: 核验前 status = 1, 2, 11 ; 核验后 status = 3 && 相应环节内没更改过套餐
const canChangeActivity: ComputedRef<boolean> = computed(() => {
  let status = detail.status
  if (status === 1 || status === 2 || status === 11) {
    return detail.is_change === 0
  }
  if (status === 3) {
    return detail.is_change === 1 || detail.is_change === 0
  }
  return false
})

const isInited = ref(false)
async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  try {
    let data: RecordDetail = await getApplyRecordDetail({ guid })
    for (let key in detail) {
      detail[key] = data[key]
    }
    detail.detail = detail.detail.filter(
      (item: RecordDetailKeyDetail) => item.exchange_product_code !== '15-001-00056'
    )
    detail.pay_status = Number(detail.pay_status)
    detail.status = Number(detail.status)
    detail.create_at_unix = dayjs(detail.create_at).unix()
    // detail.status = 7
    // detail.pay_status = 22

    detail.status_text =
      !isOldRecord.value && (detail.status === 3 || detail.status === 11)
        ? payStatusTextMap.get(detail.pay_status + '')
        : detail.status === 3
        ? '待用户支付'
        : detail.status_text
    detail.status_color = statusColorMap.get(detail.status + '')
    let childProductMap = data.detail.reduce(
      (result: RecordDetailReduceDetail, item: RecordDetailKeyDetail) => {
        let current = result[item.exchange_product_code]
        if (current) {
          current.count++
        } else {
          result[item.exchange_product_code] = {
            child_product_guid: '',
            count: 1,
            guid: item.exchange_product_guid,
            images: item.images,
            is_main: 1,
            name: item.exchange_product_name,
            price: 0,
            product_guid: '',
            tax_rate: 0,
          }
        }
        return result
      },
      {}
    )
    detail.new_product_child = Object.keys(childProductMap).map((key) => childProductMap[key])
    Toast.clear()
    console.log('data', data)
  } catch (error) {
    if ((error as { status: number }).status === 4304) {
      Toast.fail('登录失效,请重新登录后重试')
    } else {
      Toast.fail((error as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
    onLeftClick()
  }
  isInited.value = true
  refreshing.value = false
}
const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}
const popupsShow = ref(false)
function onUpdatePopupShow(show: boolean) {
  popupsShow.value = show
}
const popupShow: ComputedRef<boolean> = computed(() => {
  return cancelReasonShow.value || popupsShow.value
})
initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "申请详情",
      isReturnLeftEvent: "",
      onLeftClick: _unref(onLeftClick)
    }, null, 8, ["onLeftClick"]),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        (isInited.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "title",
                  style: _normalizeStyle('color:' + detail.status_color)
                }, _toDisplayString(detail.status_text), 5),
                (_unref(statusRemark))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["tips", detail.status === 7 ? 'text-red' : ''])
                    }, _toDisplayString(_unref(statusRemark)), 3))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(RecordProductWrapper, {
                productGuid: detail.new_product.guid,
                productName: detail.new_product.name,
                productImages: detail.new_product.images,
                productChild: detail.new_product_child,
                guid: detail.guid,
                title: detail.client_name,
                status: detail.status,
                payStatus: detail.pay_status,
                price: detail.price,
                canChange: _unref(canChangeActivity),
                isOldRecord: _unref(isOldRecord),
                onUpdatePopupShow: onUpdatePopupShow
              }, null, 8, ["productGuid", "productName", "productImages", "productChild", "guid", "title", "status", "payStatus", "price", "canChange", "isOldRecord"]),
              _createVNode(RecordBlockWrapper, {
                title: "旧设备信息",
                class: "device-info"
              }, _createSlots({
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_6, [
                    _createElementVNode("li", null, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, _toDisplayString(detail.brand_text), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(detail.model || '-'), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, _toDisplayString(detail.product_sn || '-'), 1)
                    ]),
                    _hoisted_13
                  ])
                ]),
                _: 2
              }, [
                (_unref(canEditRecord))
                  ? {
                      name: "title-right",
                      fn: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "device-info-edit xag-flex-lr",
                          onClick: toEditRecord
                        }, _hoisted_5)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024),
              _createVNode(RecordBlockWrapper, {
                title: "单据信息",
                class: "device-info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", null, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, _toDisplayString(detail.sn), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(detail.create_at), 1)
                    ]),
                    (!_unref(isOldRecord) && detail.pay_status > 11)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(front_money_pay_at) || ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.verification_at)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, _toDisplayString(detail.verification_at || ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.pay_status > 21)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(rest_money_pay_at) || ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.send_time)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, _toDisplayString(detail.send_time || ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.status === 6)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, _toDisplayString(detail.update_at || ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.status === 7)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, _toDisplayString(detail.update_at || ''), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(Popup), {
      show: cancelReasonShow.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((cancelReasonShow).value = $event)),
      "safe-area-inset-bottom": "",
      round: "",
      position: "bottom",
      style: _normalizeStyle({ height: 'auto', maxHeight: `${_unref(pHeightMax)}px` })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("i", {
              class: "icon-close-svg",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (cancelReasonShow.value = false), ["stop"]))
            })
          ]),
          _createElementVNode("div", {
            class: "popup-content",
            style: _normalizeStyle({ maxHeight: `${_unref(pHeightMax)}px` })
          }, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                (detail.pay_status > 11)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, " 是否确认取消申请？取消后定金将不予退还。 "))
                  : _createCommentVNode("", true),
                _hoisted_43
              ]),
              _createVNode(_unref(RadioGroup), {
                modelValue: cancelRemark.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cancelRemark).value = $event)),
                "checked-color": checkColor,
                "icon-size": "18",
                class: "radio-wrap"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reasonList), (reason) => {
                    return (_openBlock(), _createBlock(_unref(Radio), {
                      key: reason,
                      class: "radio-item",
                      name: reason
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reason), 1)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_unref(Button), {
                  square: "",
                  type: "success",
                  class: "xa-vant-button-cancel btn-cancel",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelReasonShow.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 考虑看看 ")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  square: "",
                  type: "success",
                  class: "xa-vant-button",
                  onClick: cancelOrderHandle
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确定")
                  ]),
                  _: 1
                })
              ])
            ])
          ], 4)
        ])
      ]),
      _: 1
    }, 8, ["show", "style"]),
    (_unref(showFooter) && !_unref(popupShow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            (_unref(showCancelSubButton))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  square: "",
                  type: "success",
                  class: "xa-vant-button-cancel btn-cancel",
                  onClick: showCancelOrderReason
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 取消申请 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: _normalizeClass(_unref(buttonClass)),
              onClick: buttonClickHandle
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_47
  ], 64))
}
}

})